import * as _types2 from "@babel/types";
var _types = "default" in _types2 ? _types2.default : _types2;
var exports = {};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isTransparentExprWrapper = isTransparentExprWrapper;
exports.skipTransparentExprWrapperNodes = skipTransparentExprWrapperNodes;
exports.skipTransparentExprWrappers = skipTransparentExprWrappers;
var _t = _types;
const {
  isParenthesizedExpression,
  isTSAsExpression,
  isTSNonNullExpression,
  isTSSatisfiesExpression,
  isTSTypeAssertion,
  isTypeCastExpression
} = _t;
function isTransparentExprWrapper(node) {
  return isTSAsExpression(node) || isTSSatisfiesExpression(node) || isTSTypeAssertion(node) || isTSNonNullExpression(node) || isTypeCastExpression(node) || isParenthesizedExpression(node);
}
function skipTransparentExprWrappers(path) {
  while (isTransparentExprWrapper(path.node)) {
    path = path.get("expression");
  }
  return path;
}
function skipTransparentExprWrapperNodes(node) {
  while (isTransparentExprWrapper(node)) {
    node = node.expression;
  }
  return node;
}

//# sourceMappingURL=index.js.map
export default exports;
export const __esModule = exports.__esModule;
const _isTransparentExprWrapper = exports.isTransparentExprWrapper,
  _skipTransparentExprWrapperNodes = exports.skipTransparentExprWrapperNodes,
  _skipTransparentExprWrappers = exports.skipTransparentExprWrappers;
export { _isTransparentExprWrapper as isTransparentExprWrapper, _skipTransparentExprWrapperNodes as skipTransparentExprWrapperNodes, _skipTransparentExprWrappers as skipTransparentExprWrappers };